import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {factoryBankDetailsFormFields} from "../../configs/factory-bank-details-form-fields";
import {EmailMaskDirective} from "../../../../../../../../shared/directives/email-mask.directive";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {ErrorService} from "../../../../../../../../core/services/error.service";
import {factoryBankDetailsResourceType} from "../../configs/factory-bank-details-modal-configs";
import {PhoneMaskDirective} from "../../../../../../../../shared/directives/phone-mask.directive";
import {CreateFactoryBankDetails, FactoryBankDetails} from "../../types/factory-bank-details-modal.types";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {FactoryBankDetailsModalService} from "../../services/factory-bank-details-modal.service";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-factory-bank-details-form',
  imports: [
    MatLabel,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    EmailMaskDirective,
    CdkTextareaAutosize,
    PhoneMaskDirective,
    MatButton
  ],
  templateUrl: './factory-bank-details-form.component.html',
  styleUrl: './factory-bank-details-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FactoryBankDetailsFormComponent {
  technicalParametersId = input.required<number>()
  factoryBankDetailsData = input.required<FactoryBankDetails>();
  factoryBankDetailsFormGroup = input.required<FormGroup>();
  noFirstData = input<boolean>(false);
  isEditModeActive = input<boolean>(false);
  updateFactoryBankDetailsData = output<FactoryBankDetails>();
  deleteFactoryBankDetailsData = output<void>();
  setLoadingState = output<boolean>();

  private errorService: ErrorService = inject(ErrorService);
  private factoryBankDetailsModalService: FactoryBankDetailsModalService = inject(FactoryBankDetailsModalService);

  public readonly factoryBankDetailsFormFields = factoryBankDetailsFormFields;

  public getFieldClass(): string {
    if (!this.factoryBankDetailsData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.factoryBankDetailsData().id) { return; }

    const isFieldValid = this.factoryBankDetailsFormGroup().get(key)?.valid;
    if (!isFieldValid) {
      this.errorService.showErrorMessage('Неправильный формат!');
      return;
    }

    const params: RecordUpdateRequestParams = {
      path: factoryBankDetailsResourceType.path,
      recordId: this.factoryBankDetailsData().id,
      fieldName: key,
      value: this.factoryBankDetailsFormGroup().get(key)?.value
    };

    const data = await this.factoryBankDetailsModalService.updatedRecordField<FactoryBankDetails>(params)
      .catch(() => this.factoryBankDetailsData());
    this.updateFactoryBankDetailsData.emit(data);
  }

  public handleDeleteData(): void {
    this.deleteFactoryBankDetailsData.emit();
  }

  public async handleCreateData(): Promise<void> {
    this.setLoadingState.emit(true);
    const params: CreateFactoryBankDetails = {
      technicalParametersId: this.technicalParametersId(),
      ...this.factoryBankDetailsFormGroup().value
    };

    await this.factoryBankDetailsModalService.createFactoryBankDetails(params)
      .then((data) => this.updateFactoryBankDetailsData.emit(data))
      .finally(() => this.setLoadingState.emit(false));
  }
}
